import React from 'react';
import ReportingDashboardNewPage from '../components/ReportingDashboardNewPage';

const ReportingDashboardNewApp = (props) => (
  <ReportingDashboardNewPage {...props} />
);

export default ReportingDashboardNewApp;
